import React, { useEffect, useState } from 'react';
import { Col, Row, Container } from 'reactstrap';
import fab from '../images/reason1.png';
import cupboard from '../images/reason2.png';
import pencil from '../images/reason3.png';
import garant from '../images/reason4.png';
import MapContacts from './MapContacts';
import { CustomCarousel } from './Carousel';
import { DTour } from './3DTour';

import sovKitchen1 from '../images/sovKitchen1.jpg';
import sovKitchen2 from '../images/sovKitchen2.jpg';
import sovKitchen3 from '../images/sovKitchen3.jpg';

import neoKitchen1 from '../images/neoKitchen1.jpg';
import neoKitchen2 from '../images/neoKitchen2.jpg';

import classickKitchen1 from '../images/classickKitchen1.jpg';
import classickKitchen2 from '../images/classickKitchen2.jpg';

const items = [
	{
		src: sovKitchen1,
		type: 0,
		alt: 'Современная кухня',
		caption: 'Современные кухни'
	},
	{
		src: neoKitchen1,
		type: 2,
		alt: 'Неоклассическая кухня',
		caption: 'Неоклассические кухни'
	},
	{
		src: classickKitchen1,
		type: 1,
		alt: 'Классическая кухня',
		caption: 'Классические кухни'
	},
	{
		src: sovKitchen2,
		type: 0,
		alt: 'Современная кухня',
		caption: 'Современные кухни'
	},
	{
		src: neoKitchen2,
		type: 2,
		alt: 'Неоклассическая кухня',
		caption: 'Неоклассические кухни'
	},
	{
		src: classickKitchen2,
		type: 1,
		alt: 'Классическая кухня',
		caption: 'Классические кухни'
	},
	{
		src: sovKitchen3,
		type: 0,
		alt: 'Современная кухня',
		caption: 'Современные кухни'
	}
];

const Home = () => {
	const [events, setEvents] = useState([]);

	useEffect(() => {
		let isMounted = true;

		const fetchEvents = async () => {
			try {
				const response = await fetch('api/DataforDB/GetActiveEvent');

				if (!response.ok) {
					throw new Error(response.statusText);
				}

				const data = await response.json();

				if (!isMounted) return;

				const formatted = Array.isArray(data)
					? data.map(x => ({
							src: x.imagePath,
							alt: x.name,
							caption: x.name
					  }))
					: [];

				setEvents(formatted);
			} catch (error) {
				console.error('Error fetching events:', error);
				if (isMounted) setEvents([]);
			}
		};

		fetchEvents();

		return () => {
			isMounted = false;
		};
	}, []);

	return (
		<Container>
			<div className='landing-container'>
				<h1 className='lending-title'>
					На<span>ш</span> к<span>а</span>талог
				</h1>

				<div className='carousel-layout'>
					<CustomCarousel items={items} />
				</div>
			</div>

			{events.length > 0 && (
				<div className='landing-container'>
					<h2 className='lending-title'>
						{events.length > 1 ? 'Текущие акции' : 'Текущая акция'}
					</h2>

					<div className='action-image carousel-layout'>
						<CustomCarousel items={events} isEvents={true} />
					</div>
				</div>
			)}

			<div className='landing-container'>
				<h2 className='lending-title'>
					ПОЧЕМУ СТ<span>О</span>ИТ ВЫБРАТЬ Н<span>А</span>С
				</h2>

				<Row>
					<Col md={6}>
						<div className='reason'>
							<img className='reason-image' alt='fab' src={fab} />
							<h3 className='reason-title'>ФАБРИЧНОЕ ПРОИЗВОДСТВО</h3>
							<div>
								Наше производство занимает площадь более 3000 кв. метров и
								оснащено современным оборудованием.
							</div>
						</div>
					</Col>

					<Col md={6}>
						<div className='reason'>
							<img className='reason-image' alt='cupboard' src={cupboard} />
							<h3 className='reason-title'>БЕСПЛАТНЫЙ ДИЗАЙН КУХНИ</h3>
							<div>
								Наши профессиональные дизайнеры создадут для вас уникальный
								проект кухни абсолютно бесплатно!
							</div>
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={6}>
						<div className='reason'>
							<img className='reason-image' alt='pencil' src={pencil} />
							<h3 className='reason-title'>БЕСПЛАТНЫЙ ЗАМЕР</h3>
							<div>
								Мы предлагаем бесплатные замеры для вашего удобства!
							</div>
						</div>
					</Col>

					<Col md={6}>
						<div className='reason'>
							<img className='reason-image' alt='garant' src={garant} />
							<h3 className='reason-title'>ГАРАНТИЯ 1 ГОД</h3>
							<div>
								Мы предоставляем гарантию на один год на все изделия.
							</div>
						</div>
					</Col>
				</Row>
			</div>

			<div className='landing-container'>
				<h2 className='lending-title'>
					Прогуля<span>й</span>тесь по нашем<span>у</span> шоурум<span>у</span>
				</h2>

				<div>
					<DTour />
				</div>
			</div>

			<div className='landing-container'>
				<h2 className='lending-title'>
					Где н<span>a</span>с найти<span>?</span>
				</h2>

				<div>
					<MapContacts />
				</div>
			</div>
		</Container>
	);
};

export default Home;